import React from 'react';
import { various } from '../../models/various';
import DrinkElement from './DrinkElement';

export interface DrinkListProps {
    various?: various
}

function DrinkList(props: DrinkListProps) {
    return (
        <div>
            <div className='menu-title'>Bibite e Altro</div>
            <div className='menu-content'>

                <DrinkElement element='Acqua 75.cl' price={props.various?.acqua75} />
                <DrinkElement element='Bibite' description='Italiane/Bio' price={props.various?.bibite} />
                <DrinkElement element='Vino della casa 0.25lt' price={props.various?.vinoQuarto} />
                <DrinkElement element='Vino della casa 0.5lt' price={props.various?.vinoMezzo} />
                <DrinkElement element='Vino della casa 1lt' price={props.various?.vino1} />
            </div>
        </div>
    );
}

export default DrinkList;